import { SwapOutlined } from '@ant-design/icons';

export const EmptyTransfers = () => {
  return (
    <div className="mt-20 flex flex-col items-center text-center">
      <span className="mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-indigo-500/10 ring-1 ring-indigo-400/30">
        <SwapOutlined className="text-indigo-300" style={{ fontSize: 24 }} />
      </span>
      <h3 className="text-base font-semibold leading-6 text-slate-100">
        No transfers yet
      </h3>
      <p className="mt-2 max-w-md text-sm leading-6 text-slate-400">
        Move funds across currencies, including stablecoins. If you are looking
        to on/off-ramp, create a new transfer.
      </p>
    </div>
  );
};
